import styled, { css } from 'styled-components';
import { Menu } from 'antd';
import { ApiOutlined, DownOutlined, CreditCardOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';

import * as Colors from '../../attrs/colors';

export const StyledMenu = styled(Menu)`
  min-width: 180px;

  .ant-dropdown-menu-item-disabled {
    color: inherit;
    cursor: default;
    font-weight: bold;

    :hover {
      color: inherit;
      cursor: default;
    }
  }
`;

const baseIcon = css`
  margin-right: 8px;
`;

export const UserIcon = styled(UserOutlined)`
  ${baseIcon}
`;

export const ApiIcon = styled(ApiOutlined)`
  ${baseIcon}
`;

export const CreditCardIcon = styled(CreditCardOutlined)`
  ${baseIcon}
`;

export const LogoutIcon = styled(LogoutOutlined)`
  ${baseIcon}
`;

export const DownIcon = styled(DownOutlined)`
  opacity: 0.5;
  font-size: 0.7rem;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  cursor: pointer;
`;

export const Avatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 32px;
  height: 32px;
  background: ${Colors.BLACK};
  color: ${Colors.WHITE};
  border-radius: 100%;
  margin-right: 0.25rem;
`;

export const Name = styled.span`
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  margin-right: 10px;
`;
